import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Building2, UserCheck, History, DatabaseBackup, Download, Landmark, Globe2 } from 'lucide-react';
import { Reveal, Eyebrow, H2 } from './ui';

const BADGES = [
  [Landmark, 'Follows India’s DPDP Act', 'Built around the Digital Personal Data Protection Act, 2023.', 'dpdp'],
  [Globe2, 'GDPR compliant', 'Data-handling practices aligned with the EU GDPR.', 'gdpr'],
  [Lock, 'Encrypted connections', 'Every page and file travels over HTTPS/TLS.', 'encryption'],
  [Building2, 'Your data stays yours', 'Each workshop’s records are kept separate. No one else can see them.', 'isolation'],
  [UserCheck, 'Staff permissions', 'Choose which staff member can open which module.', 'permissions'],
  [History, 'Activity log', 'Sensitive actions are recorded with who did it and when.', 'activity-log'],
  [DatabaseBackup, 'Regular backups', 'Your database is backed up on a regular schedule.', 'backups'],
  [Download, 'Export any time', 'Take your customers, invoices and stock out whenever you want.', 'export'],
];

export const TrustSection = () => (
  <section className="bg-[#ffffff] py-20 sm:py-28" data-testid="trust-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Eyebrow>Privacy & security</Eyebrow>
      <H2>Your customers’ data is safe with us.</H2>
      <p className="mt-4 max-w-2xl text-base text-[#475569]">
        Phone numbers, vehicle details and invoices are the heart of your workshop. We protect them the way we protect our own.
      </p>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {BADGES.map(([Icon, title, text, id], i) => (
          <Reveal key={id} delay={i * 60} className="group rounded-3xl border border-[#e2e0d8] bg-[#faf9f6] p-6 transition-colors duration-300 hover:border-[#0f766e]/40" data-testid={`trust-badge-${id}`}>
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#0f766e]/10 text-[#0f766e] transition-transform duration-300 group-hover:-translate-y-0.5">
              <Icon className="h-5 w-5" />
            </span>
            <p className="mt-4 font-semibold text-[#0f172a]">{title}</p>
            <p className="mt-1.5 text-sm leading-relaxed text-[#475569]">{text}</p>
          </Reveal>
        ))}
      </div>
      <Link to="/driveline/privacy" className="mt-8 inline-block text-sm font-semibold text-[#0f766e] hover:text-[#0f172a]" data-testid="trust-privacy-link">Privacy & security details →</Link>
    </div>
  </section>
);
